import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { escape } from 'underscore';

import { VideogularComponent } from './Videogular.Component';

const defaultChapterImage = '/img/chapter-placeholder.svg';

@Component({
	selector: 'vg-chapter-display',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
	styleUrls: ['./VgChapterDisplay.Component.ng.less', './VbMediaClick.Directive.ng.less'],
	template: `
		<div
			class="chapter-display"
			vbImageLoad
			[bgImageUri]="backgroundImageUri()">
		</div>
  `,
})
export class VgChapterDisplayComponent {
	constructor(
		private vgApi: VideogularComponent
	) { }

	public readonly backgroundImageUri = computed(() => {
		const chapter = this.vgApi.chapterHelper?.currentChapter();
		const imageUri = chapter?.url || defaultChapterImage;
		return imageUri;
	});
}
